var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: "历史记录",
            visible: _vm.drawer,
            "append-to-body": true,
            "custom-class": "pop-history",
            "show-close": false,
            size: "640px",
            direction: "rtl",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "history-order" },
            [
              _c(
                "el-dropdown",
                {
                  attrs: { trigger: "click" },
                  on: { command: _vm.toggleOrder },
                },
                [
                  _c("span", { staticClass: "el-dropdown-link hand" }, [
                    _vm._v(" " + _vm._s(_vm.orderTitle)),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right",
                    }),
                  ]),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c("el-dropdown-item", { attrs: { command: "1" } }, [
                        _vm._v("按记录时间顺序"),
                      ]),
                      _c("el-dropdown-item", { attrs: { command: "2" } }, [
                        _vm._v("按记录时间倒序"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "history-list" },
            _vm._l(_vm.timeline, function (item, index) {
              return _c("div", { key: index, staticClass: "item-history" }, [
                _c("div", { staticClass: "photo" }, [
                  _c("div", { class: "i-status i-" + item.changeType }),
                ]),
                _c(
                  "div",
                  { staticClass: "con" },
                  [
                    _c("div", { staticClass: "title-con" }, [
                      _c("div", [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(item.changeTypeLabel)),
                        ]),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(item.createdByDeptName) +
                              " " +
                              _vm._s(item.createdByName)
                          ),
                        ]),
                      ]),
                      item.changeType == 2 && item.actProcInstId
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn-look",
                                  attrs: {
                                    type: "primary",
                                    plain: "",
                                    size: "mini",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onApproveDetail(
                                        item.actProcInstId
                                      )
                                    },
                                  },
                                },
                                [_vm._v("审批详情")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "time" }, [
                      _vm._v(_vm._s(item.createdTime)),
                    ]),
                    item.changeType == 1
                      ? [
                          item.phoneData
                            ? _c(
                                "div",
                                {
                                  staticClass: "content clearfix",
                                  class: { "content-open": item.show },
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "创建时间：" +
                                          _vm._s(item.phoneData.createdTime)
                                      ),
                                    ]),
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "创建人：" +
                                          _vm._s(item.phoneData.createdByName)
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "手机号：" +
                                          _vm._s(item.phoneData.phone)
                                      ),
                                    ]),
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "实名人：" + _vm._s(item.phoneData.name)
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "more-con" }, [
                                    _c("div", [
                                      _vm._v(
                                        "运营商：" +
                                          _vm._s(
                                            item.phoneData.phoneOperatorLabel
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "手机号备注：" +
                                          _vm._s(item.phoneData.remarks)
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-more",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleMore(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.show ? "收起" : "展开") +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "icon el-icon-d-arrow-right",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          item.wechatData
                            ? _c(
                                "div",
                                {
                                  staticClass: "content clearfix",
                                  class: { "content-open": item.show },
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "创建时间：" +
                                          _vm._s(item.wechatData.createdTime)
                                      ),
                                    ]),
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "创建人：" +
                                          _vm._s(item.wechatData.createdByName)
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "微信号：" +
                                          _vm._s(item.wechatData.account)
                                      ),
                                    ]),
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v("微信号密码： "),
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            item.myPassword
                                              ? "eye-con"
                                              : "eye-con-hide",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.onEye(
                                                index,
                                                item,
                                                item.wechatData.password
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v(_vm._s(item.myPassword)),
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "default" },
                                            [_vm._v("******")]
                                          ),
                                          _c("i", { staticClass: "i-eye" }),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "more-con" }, [
                                    _c("div", [
                                      _vm._v(
                                        "微信号实名人：" +
                                          _vm._s(item.wechatData.name)
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "微信号绑定手机号：" +
                                          _vm._s(item.wechatData.phone)
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "绑定手机号员工：" +
                                          _vm._s(item.wechatData.phoneOwner)
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "微信好友数：" +
                                          _vm._s(
                                            item.wechatData.friendsCount || 0
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "微信号备注：" +
                                          _vm._s(item.wechatData.remarks)
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-more",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleMore(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.show ? "收起" : "展开") +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "icon el-icon-d-arrow-right",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          item.qqData
                            ? _c(
                                "div",
                                {
                                  staticClass: "content clearfix",
                                  class: { "content-open": item.show },
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "创建时间：" +
                                          _vm._s(item.qqData.createdTime)
                                      ),
                                    ]),
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "创建人：" +
                                          _vm._s(item.qqData.createdByName)
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "QQ号：" + _vm._s(item.qqData.account)
                                      ),
                                    ]),
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v("QQ号密码： "),
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            item.myPassword
                                              ? "eye-con"
                                              : "eye-con-hide",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.onEye(
                                                index,
                                                item,
                                                item.qqData.password
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v(_vm._s(item.myPassword)),
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "default" },
                                            [_vm._v("******")]
                                          ),
                                          _c("i", { staticClass: "i-eye" }),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "more-con" }, [
                                    _c("div", [
                                      _vm._v(
                                        "QQ号实名人：" +
                                          _vm._s(item.qqData.name)
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "QQ号绑定手机号：" +
                                          _vm._s(item.qqData.phone)
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "绑定手机号员工：" +
                                          _vm._s(item.qqData.phoneOwner)
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "QQ好友数：" +
                                          _vm._s(item.qqData.friendsCount || 0)
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "QQ号备注：" +
                                          _vm._s(item.qqData.remarks)
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-more",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleMore(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.show ? "收起" : "展开") +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "icon el-icon-d-arrow-right",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          item.emailData
                            ? _c(
                                "div",
                                {
                                  staticClass: "content clearfix",
                                  class: { "content-open": item.show },
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "创建时间：" +
                                          _vm._s(item.emailData.createdTime)
                                      ),
                                    ]),
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "创建人：" +
                                          _vm._s(item.emailData.createdByName)
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "工作邮箱：" +
                                          _vm._s(item.emailData.account)
                                      ),
                                    ]),
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v("邮箱密码： "),
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            item.myPassword
                                              ? "eye-con"
                                              : "eye-con-hide",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.onEye(
                                                index,
                                                item,
                                                item.emailData.password
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v(_vm._s(item.myPassword)),
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "default" },
                                            [_vm._v("******")]
                                          ),
                                          _c("i", { staticClass: "i-eye" }),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "more-con" }, [
                                    _c("div", [
                                      _vm._v(
                                        "邮箱实名人：" +
                                          _vm._s(item.emailData.name)
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "邮箱绑定手机号：" +
                                          _vm._s(item.emailData.phone)
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "绑定手机号员工：" +
                                          _vm._s(item.emailData.phoneOwner)
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "邮箱备注：" +
                                          _vm._s(item.emailData.remarks)
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-more",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleMore(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.show ? "收起" : "展开") +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "icon el-icon-d-arrow-right",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          item.platformData
                            ? _c(
                                "div",
                                {
                                  staticClass: "content clearfix",
                                  class: { "content-open": item.show },
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "创建时间：" +
                                          _vm._s(item.platformData.createdTime)
                                      ),
                                    ]),
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "创建人：" +
                                          _vm._s(
                                            item.platformData.createdByName
                                          )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      "主账号使用状态：" +
                                        _vm._s(
                                          item.platformData.usingStatus == 1
                                            ? "使用中"
                                            : "已停用"
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      "登录网址：" +
                                        _vm._s(item.platformData.loginUrl)
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "more-con" },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "是否有子账号：" +
                                            _vm._s(
                                              item.platformData.hasSubsidiary ==
                                                0
                                                ? "否"
                                                : "是"
                                            )
                                        ),
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "所属平台：" +
                                            _vm._s(
                                              item.platformData.platformName
                                            )
                                        ),
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "注册形式：" +
                                            _vm._s(
                                              item.platformData.regType == 1
                                                ? "公司"
                                                : "个人"
                                            )
                                        ),
                                      ]),
                                      item.platformData.regType == 1
                                        ? [
                                            _c("div", [
                                              _vm._v(
                                                "公司主体：" +
                                                  _vm._s(
                                                    item.platformData
                                                      .companyName
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                "法人/经营人：" +
                                                  _vm._s(
                                                    item.platformData
                                                      .legalPerson
                                                  )
                                              ),
                                            ]),
                                          ]
                                        : _vm._e(),
                                      _c("div", [
                                        _vm._v(
                                          "账号名称：" +
                                            _vm._s(
                                              item.platformData.accountName
                                            )
                                        ),
                                      ]),
                                      _c("div", { staticClass: "line" }),
                                      _c("div", { staticClass: "title-text" }, [
                                        _vm._v("主账号"),
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "登录账号：" +
                                            _vm._s(
                                              item.platformData.mainAccount
                                                .account
                                            )
                                        ),
                                      ]),
                                      _c("div", [
                                        _vm._v("账号密码： "),
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              item.myPassword
                                                ? "eye-con"
                                                : "eye-con-hide",
                                            ],
                                            on: {
                                              click: function ($event) {
                                                return _vm.onEyeAccount(
                                                  "main",
                                                  index,
                                                  item,
                                                  item.platformData.mainAccount
                                                    .password
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text" },
                                              [_vm._v(_vm._s(item.myPassword))]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "default" },
                                              [_vm._v("******")]
                                            ),
                                            _c("i", { staticClass: "i-eye" }),
                                          ]
                                        ),
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "账号使用人：" +
                                            _vm._s(
                                              item.platformData.mainAccount
                                                .usingUserNameList &&
                                                item.platformData.mainAccount.usingUserNameList.toString()
                                            )
                                        ),
                                      ]),
                                      _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col" }, [
                                          _vm._v(
                                            "账号绑定手机号：" +
                                              _vm._s(
                                                item.platformData.mainAccount
                                                  .phone
                                              )
                                          ),
                                        ]),
                                        _c("div", { staticClass: "col" }, [
                                          _vm._v(
                                            "绑定手机号员工：" +
                                              _vm._s(
                                                item.platformData.mainAccount
                                                  .phoneOwnerName
                                              )
                                          ),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col" }, [
                                          _vm._v(
                                            "账号绑定微信号：" +
                                              _vm._s(
                                                item.platformData.mainAccount
                                                  .wechat
                                              )
                                          ),
                                        ]),
                                        _c("div", { staticClass: "col" }, [
                                          _vm._v(
                                            "绑定微信号员工：" +
                                              _vm._s(
                                                item.platformData.mainAccount
                                                  .wechatOwnerName
                                              )
                                          ),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col" }, [
                                          _vm._v(
                                            "账号绑定QQ号：" +
                                              _vm._s(
                                                item.platformData.mainAccount.qq
                                              )
                                          ),
                                        ]),
                                        _c("div", { staticClass: "col" }, [
                                          _vm._v(
                                            "绑定QQ号员工：" +
                                              _vm._s(
                                                item.platformData.mainAccount
                                                  .qqOwnerName
                                              )
                                          ),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col" }, [
                                          _vm._v(
                                            "账号绑定邮箱：" +
                                              _vm._s(
                                                item.platformData.mainAccount
                                                  .email
                                              )
                                          ),
                                        ]),
                                        _c("div", { staticClass: "col" }, [
                                          _vm._v(
                                            "绑定邮箱员工：" +
                                              _vm._s(
                                                item.platformData.mainAccount
                                                  .emailOwnerName
                                              )
                                          ),
                                        ]),
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "是否有ID：" +
                                            _vm._s(
                                              item.platformData.mainAccount
                                                .hasId == 0
                                                ? "否"
                                                : "是"
                                            )
                                        ),
                                      ]),
                                      item.platformData.mainAccount.hasId == 1
                                        ? _vm._l(
                                            item.platformData.mainAccount
                                              .accountIdList,
                                            function (accountIdItem, index2) {
                                              return _c(
                                                "div",
                                                { key: index + "-" + index2 },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "col" },
                                                        [
                                                          _vm._v(
                                                            "账号ID(" +
                                                              _vm._s(
                                                                _vm.makeIndex(
                                                                  index2
                                                                )
                                                              ) +
                                                              ")：" +
                                                              _vm._s(
                                                                accountIdItem.accountId
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        { staticClass: "col" },
                                                        [
                                                          _vm._v(
                                                            "所属五域类目：" +
                                                              _vm._s(
                                                                accountIdItem.categoryName
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "col" },
                                                        [
                                                          _vm._v(
                                                            "渠道号：" +
                                                              _vm._s(
                                                                accountIdItem.channelName
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        { staticClass: "col" },
                                                        [
                                                          _vm._v(
                                                            "ID使用状态：" +
                                                              _vm._s(
                                                                accountIdItem.status ==
                                                                  1
                                                                  ? "开启"
                                                                  : "停用"
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          )
                                        : _vm._e(),
                                      item.platformData.hasSubsidiary == 1 &&
                                      item.platformData.subAccountList.length >
                                        0
                                        ? [
                                            _c("div", { staticClass: "line" }),
                                            _vm._l(
                                              item.platformData.subAccountList,
                                              function (
                                                subAccountItem,
                                                subIndex
                                              ) {
                                                return _c(
                                                  "div",
                                                  { key: subIndex },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "title-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "子账号(" +
                                                            _vm._s(
                                                              _vm.makeIndex(
                                                                subIndex
                                                              )
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    ),
                                                    _c("div", [
                                                      _vm._v(
                                                        "登录账号：" +
                                                          _vm._s(
                                                            subAccountItem.account
                                                          )
                                                      ),
                                                    ]),
                                                    _c("div", [
                                                      _vm._v("账号密码： "),
                                                      _c(
                                                        "span",
                                                        {
                                                          class: [
                                                            subAccountItem.myPassword
                                                              ? "eye-con"
                                                              : "eye-con-hide",
                                                          ],
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onEyeAccount(
                                                                "sub",
                                                                index,
                                                                item,
                                                                subAccountItem.password,
                                                                subIndex
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  subAccountItem.myPassword
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "default",
                                                            },
                                                            [_vm._v("******")]
                                                          ),
                                                          _c("i", {
                                                            staticClass:
                                                              "i-eye",
                                                          }),
                                                        ]
                                                      ),
                                                    ]),
                                                    _c("div", [
                                                      _vm._v(
                                                        "账号使用人：" +
                                                          _vm._s(
                                                            subAccountItem.usingUserNameList &&
                                                              subAccountItem.usingUserNameList.toString()
                                                          )
                                                      ),
                                                    ]),
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "账号绑定手机号：" +
                                                                _vm._s(
                                                                  subAccountItem.phone
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "绑定手机号员工：" +
                                                                _vm._s(
                                                                  subAccountItem.phoneOwnerName
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "账号绑定微信号：" +
                                                                _vm._s(
                                                                  subAccountItem.wechat
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "绑定微信号员工：" +
                                                                _vm._s(
                                                                  subAccountItem.wechatOwnerName
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "账号绑定QQ号：" +
                                                                _vm._s(
                                                                  subAccountItem.qq
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "绑定QQ号员工：" +
                                                                _vm._s(
                                                                  subAccountItem.qqOwnerName
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "账号绑定邮箱：" +
                                                                _vm._s(
                                                                  subAccountItem.email
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "绑定邮箱员工：" +
                                                                _vm._s(
                                                                  subAccountItem.emailOwnerName
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c("div", [
                                                      _vm._v(
                                                        "是否有ID：" +
                                                          _vm._s(
                                                            subAccountItem.hasId ==
                                                              0
                                                              ? "否"
                                                              : "是"
                                                          )
                                                      ),
                                                    ]),
                                                    subAccountItem.hasId == 1
                                                      ? _vm._l(
                                                          subAccountItem.accountIdList,
                                                          function (
                                                            subAccountIdItem,
                                                            index3
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key:
                                                                  subIndex +
                                                                  "-" +
                                                                  index3,
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "row",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "账号ID(" +
                                                                            _vm._s(
                                                                              _vm.makeIndex(
                                                                                index3
                                                                              )
                                                                            ) +
                                                                            ")：" +
                                                                            _vm._s(
                                                                              subAccountIdItem.accountId
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "所属五域类目：" +
                                                                            _vm._s(
                                                                              subAccountIdItem.categoryName
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "row",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "渠道号：" +
                                                                            _vm._s(
                                                                              subAccountIdItem.channelName
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "ID使用状态：" +
                                                                            _vm._s(
                                                                              subAccountIdItem.status ==
                                                                                1
                                                                                ? "开启"
                                                                                : "停用"
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                )
                                              }
                                            ),
                                          ]
                                        : _vm._e(),
                                      _c("div", { staticClass: "line" }),
                                      _c("div", { staticClass: "title-text" }, [
                                        _vm._v("其他信息"),
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "是否有店铺：" +
                                            _vm._s(
                                              item.platformData.hasShop == 0
                                                ? "否"
                                                : "是"
                                            )
                                        ),
                                      ]),
                                      item.platformData.hasShop == 1
                                        ? _vm._l(
                                            item.platformData.shopList,
                                            function (shopItem, shopIndex) {
                                              return _c(
                                                "div",
                                                { key: "shop-" + shopIndex },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      "店铺" +
                                                        _vm._s(
                                                          _vm.makeIndex(
                                                            shopIndex
                                                          )
                                                        ) +
                                                        "名称：" +
                                                        _vm._s(
                                                          shopItem.shopName
                                                        )
                                                    ),
                                                  ]),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "col" },
                                                        [
                                                          _vm._v(
                                                            "店铺" +
                                                              _vm._s(
                                                                _vm.makeIndex(
                                                                  shopIndex
                                                                )
                                                              ) +
                                                              "ID：" +
                                                              _vm._s(
                                                                shopItem.shopId
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        { staticClass: "col" },
                                                        [
                                                          _vm._v(
                                                            "店铺" +
                                                              _vm._s(
                                                                _vm.makeIndex(
                                                                  shopIndex
                                                                )
                                                              ) +
                                                              "状态：" +
                                                              _vm._s(
                                                                shopItem.status ==
                                                                  1
                                                                  ? "开启"
                                                                  : "停用"
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          )
                                        : _vm._e(),
                                      _c("div", [
                                        _vm._v(
                                          "平台账号备注：" +
                                            _vm._s(item.platformData.remarks)
                                        ),
                                      ]),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-more",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleMore(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.show ? "收起" : "展开") +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "icon el-icon-d-arrow-right",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    item.changeType == 3
                      ? [
                          item.phoneData
                            ? _c(
                                "div",
                                {
                                  staticClass: "content clearfix",
                                  class: { "content-open": item.show },
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "更新时间：" +
                                          _vm._s(item.phoneData.updatedTime)
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        class: _vm.setMark(
                                          item,
                                          "ownerUserName"
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "最后归属人：" +
                                            _vm._s(item.phoneData.ownerUserName)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v("手机号状态: "),
                                      item.phoneData.statusLabel
                                        ? _c(
                                            "span",
                                            {
                                              class:
                                                "icon-status icon-status-" +
                                                item.phoneData.status,
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.phoneData.statusLabel
                                                  )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        class: _vm.setMark(item, "phone"),
                                      },
                                      [
                                        _vm._v(
                                          "手机号：" +
                                            _vm._s(item.phoneData.phone)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        class: _vm.setMark(item, "name"),
                                      },
                                      [
                                        _vm._v(
                                          "实名人：" +
                                            _vm._s(item.phoneData.name)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "more-con" }, [
                                    _c(
                                      "div",
                                      {
                                        class: _vm.setMark(
                                          item,
                                          "phoneOperator"
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "运营商：" +
                                            _vm._s(
                                              item.phoneData.phoneOperatorLabel
                                            )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { class: _vm.setMark(item, "remark") },
                                      [
                                        _vm._v(
                                          "手机号备注：" +
                                            _vm._s(item.phoneData.remarks)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-more",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleMore(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.show ? "收起" : "展开") +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "icon el-icon-d-arrow-right",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          item.wechatData
                            ? _c(
                                "div",
                                {
                                  staticClass: "content clearfix",
                                  class: { "content-open": item.show },
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "更新时间：" +
                                          _vm._s(item.wechatData.updatedTime)
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        class: _vm.setMark(
                                          item,
                                          "ownerUserName"
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "最后归属人：" +
                                            _vm._s(
                                              item.wechatData.ownerUserName
                                            )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v("微信号状态: "),
                                      item.wechatData.statusLabel
                                        ? _c(
                                            "span",
                                            {
                                              class:
                                                "icon-status icon-status-" +
                                                item.wechatData.status,
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.wechatData.statusLabel
                                                  )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        class: _vm.setMark(item, "account"),
                                      },
                                      [
                                        _vm._v(
                                          "微信号：" +
                                            _vm._s(item.wechatData.account)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        class: _vm.setMark(item, "password"),
                                      },
                                      [
                                        _vm._v("微信号密码： "),
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              item.myPassword
                                                ? "eye-con"
                                                : "eye-con-hide",
                                            ],
                                            on: {
                                              click: function ($event) {
                                                return _vm.onEye(
                                                  index,
                                                  item,
                                                  item.wechatData.password
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text" },
                                              [_vm._v(_vm._s(item.myPassword))]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "default" },
                                              [_vm._v("******")]
                                            ),
                                            _c("i", { staticClass: "i-eye" }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "more-con" }, [
                                    _c(
                                      "div",
                                      { class: _vm.setMark(item, "name") },
                                      [
                                        _vm._v(
                                          "微信号实名人：" +
                                            _vm._s(item.wechatData.name)
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { class: _vm.setMark(item, "phone") },
                                      [
                                        _vm._v(
                                          "微信号绑定手机号：" +
                                            _vm._s(item.wechatData.phone)
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: _vm.setMark(
                                          item,
                                          "phoneOwnerUserId"
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "绑定手机号员工：" +
                                            _vm._s(item.wechatData.phoneOwner)
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: _vm.setMark(
                                          item,
                                          "friendsCount"
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "微信好友数：" +
                                            _vm._s(
                                              item.wechatData.friendsCount || 0
                                            )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { class: _vm.setMark(item, "remark") },
                                      [
                                        _vm._v(
                                          "微信号备注：" +
                                            _vm._s(item.wechatData.remarks)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-more",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleMore(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.show ? "收起" : "展开") +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "icon el-icon-d-arrow-right",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          item.qqData
                            ? _c(
                                "div",
                                {
                                  staticClass: "content clearfix",
                                  class: { "content-open": item.show },
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "更新时间：" +
                                          _vm._s(item.qqData.updatedTime)
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        class: _vm.setMark(
                                          item,
                                          "ownerUserName"
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "最后归属人：" +
                                            _vm._s(item.qqData.ownerUserName)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v("QQ号状态: "),
                                      item.qqData.statusLabel
                                        ? _c(
                                            "span",
                                            {
                                              class:
                                                "icon-status icon-status-" +
                                                item.qqData.status,
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.qqData.statusLabel
                                                  )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        class: _vm.setMark(item, "account"),
                                      },
                                      [
                                        _vm._v(
                                          "QQ号：" + _vm._s(item.qqData.account)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        class: _vm.setMark(item, "password"),
                                      },
                                      [
                                        _vm._v("QQ号密码： "),
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              item.myPassword
                                                ? "eye-con"
                                                : "eye-con-hide",
                                            ],
                                            on: {
                                              click: function ($event) {
                                                return _vm.onEye(
                                                  index,
                                                  item,
                                                  item.qqData.password
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text" },
                                              [_vm._v(_vm._s(item.myPassword))]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "default" },
                                              [_vm._v("******")]
                                            ),
                                            _c("i", { staticClass: "i-eye" }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "more-con" }, [
                                    _c(
                                      "div",
                                      { class: _vm.setMark(item, "name") },
                                      [
                                        _vm._v(
                                          "QQ号实名人：" +
                                            _vm._s(item.qqData.name)
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { class: _vm.setMark(item, "phone") },
                                      [
                                        _vm._v(
                                          "QQ号绑定手机号：" +
                                            _vm._s(item.qqData.phone)
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: _vm.setMark(
                                          item,
                                          "phoneOwnerUserId"
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "绑定手机号员工：" +
                                            _vm._s(item.qqData.phoneOwner)
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: _vm.setMark(
                                          item,
                                          "friendsCount"
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "QQ好友数：" +
                                            _vm._s(
                                              item.qqData.friendsCount || 0
                                            )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { class: _vm.setMark(item, "remark") },
                                      [
                                        _vm._v(
                                          "QQ号备注：" +
                                            _vm._s(item.qqData.remarks)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-more",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleMore(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.show ? "收起" : "展开") +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "icon el-icon-d-arrow-right",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          item.emailData
                            ? _c(
                                "div",
                                {
                                  staticClass: "content clearfix",
                                  class: { "content-open": item.show },
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "更新时间：" +
                                          _vm._s(item.emailData.updatedTime)
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        class: _vm.setMark(
                                          item,
                                          "ownerUserName"
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "最后归属人：" +
                                            _vm._s(item.emailData.ownerUserName)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v("邮箱状态: "),
                                      item.emailData.statusLabel
                                        ? _c(
                                            "span",
                                            {
                                              class:
                                                "icon-status icon-status-" +
                                                item.emailData.status,
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.emailData.statusLabel
                                                  )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        class: _vm.setMark(item, "account"),
                                      },
                                      [
                                        _vm._v(
                                          "工作邮箱：" +
                                            _vm._s(item.emailData.account)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        class: _vm.setMark(item, "password"),
                                      },
                                      [
                                        _vm._v("邮箱密码： "),
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              item.myPassword
                                                ? "eye-con"
                                                : "eye-con-hide",
                                            ],
                                            on: {
                                              click: function ($event) {
                                                return _vm.onEye(
                                                  index,
                                                  item,
                                                  item.emailData.password
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text" },
                                              [_vm._v(_vm._s(item.myPassword))]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "default" },
                                              [_vm._v("******")]
                                            ),
                                            _c("i", { staticClass: "i-eye" }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "more-con" },
                                    [
                                      _c(
                                        "div",
                                        { class: _vm.setMark(item, "name") },
                                        [
                                          _vm._v(
                                            "邮箱实名人：" +
                                              _vm._s(item.emailData.name)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          class: _vm.setMark(item, "hasPhone"),
                                        },
                                        [
                                          _vm._v(
                                            "是否绑定手机号：" +
                                              _vm._s(
                                                item.emailData.hasPhone
                                                  ? "是"
                                                  : "否"
                                              )
                                          ),
                                        ]
                                      ),
                                      item.emailData.hasPhone
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                class: _vm.setMark(
                                                  item,
                                                  "phone"
                                                ),
                                              },
                                              [
                                                _vm._v(
                                                  "邮箱绑定手机号：" +
                                                    _vm._s(item.emailData.phone)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                class: _vm.setMark(
                                                  item,
                                                  "phone"
                                                ),
                                              },
                                              [
                                                _vm._v(
                                                  "绑定手机号员工：" +
                                                    _vm._s(
                                                      item.emailData.phoneOwner
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { class: _vm.setMark(item, "remark") },
                                        [
                                          _vm._v(
                                            "邮箱备注：" +
                                              _vm._s(item.emailData.remarks)
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-more",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleMore(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.show ? "收起" : "展开") +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "icon el-icon-d-arrow-right",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          item.platformData
                            ? _c(
                                "div",
                                {
                                  staticClass: "content clearfix",
                                  class: { "content-open": item.show },
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(
                                        "更新时间：" +
                                          _vm._s(item.platformData.createdTime)
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        class: _vm.setMark(
                                          item,
                                          "ownerUserName",
                                          item.platformData.id
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "最后归属人：" +
                                            _vm._s(
                                              item.platformData.ownerUserName
                                            )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      class: _vm.setMark(
                                        item,
                                        "usingStatus",
                                        item.platformData.id
                                      ),
                                    },
                                    [
                                      _vm._v(
                                        "主账号使用状态：" +
                                          _vm._s(
                                            item.platformData.usingStatus == 1
                                              ? "使用中"
                                              : "已停用"
                                          )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      class: _vm.setMark(
                                        item,
                                        "loginUrl",
                                        item.platformData.id
                                      ),
                                    },
                                    [
                                      _vm._v(
                                        "登录网址：" +
                                          _vm._s(item.platformData.loginUrl)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "more-con" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          class: _vm.setMark(
                                            item,
                                            "hasSubsidiary",
                                            item.platformData.id
                                          ),
                                        },
                                        [
                                          _vm._v(
                                            "是否有子账号：" +
                                              _vm._s(
                                                item.platformData
                                                  .hasSubsidiary == 0
                                                  ? "否"
                                                  : "是"
                                              )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          class: _vm.setMark(
                                            item,
                                            "platformKey",
                                            item.platformData.id
                                          ),
                                        },
                                        [
                                          _vm._v(
                                            "所属平台：" +
                                              _vm._s(
                                                item.platformData.platformName
                                              )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          class: _vm.setMark(
                                            item,
                                            "regType",
                                            item.platformData.id
                                          ),
                                        },
                                        [
                                          _vm._v(
                                            "注册形式：" +
                                              _vm._s(
                                                item.platformData.regType == 1
                                                  ? "公司"
                                                  : "个人"
                                              )
                                          ),
                                        ]
                                      ),
                                      item.platformData.regType == 1
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                class: _vm.setMark(
                                                  item,
                                                  "companyName",
                                                  item.platformData.id
                                                ),
                                              },
                                              [
                                                _vm._v(
                                                  "公司主体：" +
                                                    _vm._s(
                                                      item.platformData
                                                        .companyName
                                                    )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                class: _vm.setMark(
                                                  item,
                                                  "legalPerson",
                                                  item.platformData.id
                                                ),
                                              },
                                              [
                                                _vm._v(
                                                  "法人/经营人：" +
                                                    _vm._s(
                                                      item.platformData
                                                        .legalPerson
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          class: _vm.setMark(
                                            item,
                                            "accountName",
                                            item.platformData.id
                                          ),
                                        },
                                        [
                                          _vm._v(
                                            "账号名称：" +
                                              _vm._s(
                                                item.platformData.accountName
                                              )
                                          ),
                                        ]
                                      ),
                                      _c("div", { staticClass: "line" }),
                                      _c("div", { staticClass: "title-text" }, [
                                        _vm._v("主账号"),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          class: _vm.setMark(
                                            item,
                                            "account",
                                            item.platformData.mainAccount.id
                                          ),
                                        },
                                        [
                                          _vm._v(
                                            "登录账号：" +
                                              _vm._s(
                                                item.platformData.mainAccount
                                                  .account
                                              )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          class: _vm.setMark(
                                            item,
                                            "password",
                                            item.platformData.mainAccount.id
                                          ),
                                        },
                                        [
                                          _vm._v("账号密码： "),
                                          _c(
                                            "span",
                                            {
                                              class: [
                                                item.myPassword
                                                  ? "eye-con"
                                                  : "eye-con-hide",
                                              ],
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onEyeAccount(
                                                    "main",
                                                    index,
                                                    item,
                                                    item.platformData
                                                      .mainAccount.password
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.myPassword)
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "default" },
                                                [_vm._v("******")]
                                              ),
                                              _c("i", { staticClass: "i-eye" }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          class: _vm.setMark(
                                            item,
                                            "usingUserIdList",
                                            item.platformData.mainAccount.id
                                          ),
                                        },
                                        [
                                          _vm._v(
                                            "账号使用人：" +
                                              _vm._s(
                                                item.platformData.mainAccount
                                                  .usingUserNameList &&
                                                  item.platformData.mainAccount.usingUserNameList.toString()
                                              )
                                          ),
                                        ]
                                      ),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col",
                                            class: _vm.setMark(
                                              item,
                                              "phone",
                                              item.platformData.mainAccount.id
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              "账号绑定手机号：" +
                                                _vm._s(
                                                  item.platformData.mainAccount
                                                    .phone
                                                )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col",
                                            class: _vm.setMark(
                                              item,
                                              "phoneOwnerName",
                                              item.platformData.mainAccount.id
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              "绑定手机号员工：" +
                                                _vm._s(
                                                  item.platformData.mainAccount
                                                    .phoneOwnerName
                                                )
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col",
                                            class: _vm.setMark(
                                              item,
                                              "wechat",
                                              item.platformData.mainAccount.id
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              "账号绑定微信号：" +
                                                _vm._s(
                                                  item.platformData.mainAccount
                                                    .wechat
                                                )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col",
                                            class: _vm.setMark(
                                              item,
                                              "wechatOwnerName",
                                              item.platformData.mainAccount.id
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              "绑定微信号员工：" +
                                                _vm._s(
                                                  item.platformData.mainAccount
                                                    .wechatOwnerName
                                                )
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col",
                                            class: _vm.setMark(
                                              item,
                                              "qq",
                                              item.platformData.mainAccount.id
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              "账号绑定QQ号：" +
                                                _vm._s(
                                                  item.platformData.mainAccount
                                                    .qq
                                                )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col",
                                            class: _vm.setMark(
                                              item,
                                              "qqOwnerName",
                                              item.platformData.mainAccount.id
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              "绑定QQ号员工：" +
                                                _vm._s(
                                                  item.platformData.mainAccount
                                                    .qqOwnerName
                                                )
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col",
                                            class: _vm.setMark(
                                              item,
                                              "email",
                                              item.platformData.mainAccount.id
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              "账号绑定邮箱：" +
                                                _vm._s(
                                                  item.platformData.mainAccount
                                                    .email
                                                )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col",
                                            class: _vm.setMark(
                                              item,
                                              "emailOwnerName",
                                              item.platformData.mainAccount.id
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              "绑定邮箱员工：" +
                                                _vm._s(
                                                  item.platformData.mainAccount
                                                    .emailOwnerName
                                                )
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          class: _vm.setMark(
                                            item,
                                            "hasId",
                                            item.platformData.mainAccount.id
                                          ),
                                        },
                                        [
                                          _vm._v(
                                            "是否有ID：" +
                                              _vm._s(
                                                item.platformData.mainAccount
                                                  .hasId == 0
                                                  ? "否"
                                                  : "是"
                                              )
                                          ),
                                        ]
                                      ),
                                      item.platformData.mainAccount.hasId == 1
                                        ? _vm._l(
                                            item.platformData.mainAccount
                                              .accountIdList,
                                            function (accountIdItem, index2) {
                                              return _c(
                                                "div",
                                                { key: index + "-" + index2 },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "accountId",
                                                            accountIdItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "账号ID(" +
                                                              _vm._s(
                                                                _vm.makeIndex(
                                                                  index2
                                                                )
                                                              ) +
                                                              ")：" +
                                                              _vm._s(
                                                                accountIdItem.accountId
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "categoryId",
                                                            accountIdItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "所属五域类目：" +
                                                              _vm._s(
                                                                accountIdItem.categoryName
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "channelName",
                                                            accountIdItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "渠道号：" +
                                                              _vm._s(
                                                                accountIdItem.channelName
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "status",
                                                            accountIdItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "ID使用状态：" +
                                                              _vm._s(
                                                                accountIdItem.status ==
                                                                  1
                                                                  ? "开启"
                                                                  : "停用"
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          )
                                        : _vm._e(),
                                      item.platformData.hasSubsidiary == 1 &&
                                      item.platformData.subAccountList.length >
                                        0
                                        ? _vm._l(
                                            item.platformData.subAccountList,
                                            function (
                                              subAccountItem,
                                              subIndex
                                            ) {
                                              return _c(
                                                "div",
                                                { key: subIndex },
                                                [
                                                  _c("div", {
                                                    staticClass: "line",
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "title-text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "子账号(" +
                                                          _vm._s(
                                                            _vm.makeIndex(
                                                              subIndex
                                                            )
                                                          ) +
                                                          ")"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: _vm.setMark(
                                                        item,
                                                        "account",
                                                        subAccountItem.id
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(
                                                        "登录账号：" +
                                                          _vm._s(
                                                            subAccountItem.account
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: _vm.setMark(
                                                        item,
                                                        "password",
                                                        subAccountItem.id
                                                      ),
                                                    },
                                                    [
                                                      _vm._v("账号密码： "),
                                                      _c(
                                                        "span",
                                                        {
                                                          class: [
                                                            subAccountItem.myPassword
                                                              ? "eye-con"
                                                              : "eye-con-hide",
                                                          ],
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onEyeAccount(
                                                                "sub",
                                                                index,
                                                                item,
                                                                subAccountItem.password,
                                                                subIndex
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  subAccountItem.myPassword
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "default",
                                                            },
                                                            [_vm._v("******")]
                                                          ),
                                                          _c("i", {
                                                            staticClass:
                                                              "i-eye",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: _vm.setMark(
                                                        item,
                                                        "usingUserIdList",
                                                        subAccountItem.id
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(
                                                        "账号使用人：" +
                                                          _vm._s(
                                                            subAccountItem.usingUserNameList &&
                                                              subAccountItem.usingUserNameList.toString()
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "phone",
                                                            subAccountItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "账号绑定手机号：" +
                                                              _vm._s(
                                                                subAccountItem.phone
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "phoneOwnerName",
                                                            subAccountItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "绑定手机号员工：" +
                                                              _vm._s(
                                                                subAccountItem.phoneOwnerName
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "wechat",
                                                            subAccountItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "账号绑定微信号：" +
                                                              _vm._s(
                                                                subAccountItem.wechat
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "wechatOwnerName",
                                                            subAccountItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "绑定微信号员工：" +
                                                              _vm._s(
                                                                subAccountItem.wechatOwnerName
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "qq",
                                                            subAccountItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "账号绑定QQ号：" +
                                                              _vm._s(
                                                                subAccountItem.qq
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "qqOwnerName",
                                                            subAccountItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "绑定QQ号员工：" +
                                                              _vm._s(
                                                                subAccountItem.qqOwnerName
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "email",
                                                            subAccountItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "账号绑定邮箱：" +
                                                              _vm._s(
                                                                subAccountItem.email
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "emailOwnerName",
                                                            subAccountItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "绑定邮箱员工：" +
                                                              _vm._s(
                                                                subAccountItem.emailOwnerName
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: _vm.setMark(
                                                        item,
                                                        "hasId",
                                                        subAccountItem.id
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(
                                                        "是否有ID：" +
                                                          _vm._s(
                                                            subAccountItem.hasId ==
                                                              0
                                                              ? "否"
                                                              : "是"
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  subAccountItem.hasId == 1
                                                    ? _vm._l(
                                                        subAccountItem.accountIdList,
                                                        function (
                                                          subAccountIdItem,
                                                          index3
                                                        ) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                subIndex +
                                                                "-" +
                                                                index3,
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "row",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col",
                                                                      class:
                                                                        _vm.setMark(
                                                                          item,
                                                                          "accountId",
                                                                          subAccountIdItem.id
                                                                        ),
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "账号ID(" +
                                                                          _vm._s(
                                                                            _vm.makeIndex(
                                                                              index3
                                                                            )
                                                                          ) +
                                                                          ")：" +
                                                                          _vm._s(
                                                                            subAccountIdItem.accountId
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col",
                                                                      class:
                                                                        _vm.setMark(
                                                                          item,
                                                                          "categoryId",
                                                                          subAccountIdItem.id
                                                                        ),
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "所属五域类目：" +
                                                                          _vm._s(
                                                                            subAccountIdItem.categoryName
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "row",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col",
                                                                      class:
                                                                        _vm.setMark(
                                                                          item,
                                                                          "channelName",
                                                                          subAccountIdItem.id
                                                                        ),
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "渠道号：" +
                                                                          _vm._s(
                                                                            subAccountIdItem.channelName
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col",
                                                                      class:
                                                                        _vm.setMark(
                                                                          item,
                                                                          "status",
                                                                          subAccountIdItem.id
                                                                        ),
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "ID使用状态：" +
                                                                          _vm._s(
                                                                            subAccountIdItem.status ==
                                                                              1
                                                                              ? "开启"
                                                                              : "停用"
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              )
                                            }
                                          )
                                        : _vm._e(),
                                      _c("div", { staticClass: "line" }),
                                      _c("div", { staticClass: "title-text" }, [
                                        _vm._v("其他信息"),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          class: _vm.setMark(
                                            item,
                                            "hasShop",
                                            item.platformData.id
                                          ),
                                        },
                                        [
                                          _vm._v(
                                            "是否有店铺：" +
                                              _vm._s(
                                                item.platformData.hasShop == 0
                                                  ? "否"
                                                  : "是"
                                              )
                                          ),
                                        ]
                                      ),
                                      item.platformData.hasShop == 1
                                        ? _vm._l(
                                            item.platformData.shopList,
                                            function (shopItem, shopIndex) {
                                              return _c(
                                                "div",
                                                { key: "shop-" + shopIndex },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      class: _vm.setMark(
                                                        item,
                                                        "shopName",
                                                        shopItem.id
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(
                                                        "店铺" +
                                                          _vm._s(
                                                            _vm.makeIndex(
                                                              shopIndex
                                                            )
                                                          ) +
                                                          "名称：" +
                                                          _vm._s(
                                                            shopItem.shopName
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "shopId",
                                                            shopItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "店铺" +
                                                              _vm._s(
                                                                _vm.makeIndex(
                                                                  shopIndex
                                                                )
                                                              ) +
                                                              "ID：" +
                                                              _vm._s(
                                                                shopItem.shopId
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col",
                                                          class: _vm.setMark(
                                                            item,
                                                            "status",
                                                            shopItem.id
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            "店铺" +
                                                              _vm._s(
                                                                _vm.makeIndex(
                                                                  shopIndex
                                                                )
                                                              ) +
                                                              "状态：" +
                                                              _vm._s(
                                                                shopItem.status ==
                                                                  1
                                                                  ? "开启"
                                                                  : "停用"
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          class: _vm.setMark(
                                            item,
                                            "remarks",
                                            item.platformData.id
                                          ),
                                        },
                                        [
                                          _vm._v(
                                            "平台账号备注：" +
                                              _vm._s(item.platformData.remarks)
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-more",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleMore(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.show ? "收起" : "展开") +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "icon el-icon-d-arrow-right",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            }),
            0
          ),
        ]
      ),
      _c("pop-process", { ref: "popProcess" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }